import { SliderProduct } from './SliderProduct';

export type { TypeSliderProductProps } from './types';
export default SliderProduct;
